module.exports = __webpack_public_path__ + "static/optical-fiber-0ff37a308246f367c2ef635944a0b9da.svg";